/**
 * Small high-contrast chip that flags safety-only projects on dashboards
 * and lists. Renders nothing for any other project_type so callers can
 * sprinkle it everywhere unconditionally.
 */
import { ShieldCheck } from "lucide-react";

export default function SafetyOnlyBadge({ projectType, size = "sm", className = "" }) {
  if (projectType !== "safety_only") return null;
  const sizing =
    size === "xs"
      ? "px-1.5 py-0.5 text-[9px]"
      : "px-2 py-0.5 text-[10px]";
  return (
    <span
      data-testid="safety-only-badge"
      title="Safety-Only project — Tailgate + JSA only, no field photos"
      className={`inline-flex items-center gap-1 rounded-md border border-amber-700 bg-amber-950/50 text-amber-300 font-display font-bold tracking-[0.18em] uppercase ${sizing} ${className}`}
    >
      <ShieldCheck className={size === "xs" ? "w-2.5 h-2.5" : "w-3 h-3"} />
      Safety Only
    </span>
  );
}
